import {
    GESTIONNAIRE_CODE_FIELD,
    GESTIONNAIRE_FIELD,
    SUPER_GESTIONNAIRE_CODE_FIELD,
    SUPER_GESTIONNAIRE_FIELD,
} from 'routes/BudgetModule/config/constants';
import { ColDef } from 'ag-grid-community';

const createSuperGestionnaireColDefs = (
    enableRowGrouping: boolean,
): ColDef[] => {
    const baseColDefs = [
        {
            field: SUPER_GESTIONNAIRE_CODE_FIELD,
            sortable: true,
            filter: 'agTextColumnFilter',
            enableRowGroup: true,
            pivot: false,
            enablePivot: true,
        },
        {
            field: SUPER_GESTIONNAIRE_FIELD,
            sortable: true,
            filter: 'agTextColumnFilter',
            enableRowGroup: true,
            pivot: false,
            enablePivot: true,
        },
    ];

    if (enableRowGrouping) {
        return baseColDefs.map((colDef) => ({
            ...colDef,
            sort: 'asc',
            rowGroup: true,
            rowGroupIndex: 0,
        }));
    }

    return baseColDefs;
};

export const addSuperGestionnaireColDefs = (
    colDefs: ColDef[],
    includeRowGroupIndex = false,
): ColDef[] => {
    const superGestionnaireColDefs =
        createSuperGestionnaireColDefs(includeRowGroupIndex);

    const gestionnaireIndex = Math.max(
        colDefs.findIndex((column) => column.field === GESTIONNAIRE_FIELD),
        colDefs.findIndex((column) => column.field === GESTIONNAIRE_CODE_FIELD),
    );

    if (gestionnaireIndex === -1) {
        colDefs.push(...superGestionnaireColDefs);
    } else {
        colDefs.splice(gestionnaireIndex + 1, 0, ...superGestionnaireColDefs);
    }

    return colDefs;
};
